import { Controller} from "stimulus"

export default class extends Controller {
  static targets = ["display"]

  update(event) {
    let name = event.currentTarget.dataset.title || event.currentTarget.innerText
    this.displayTarget.innerText = name
  }
}